import {Box} from '@mui/material';
import React from 'react';
import styles from './page-wrapper.module.scss';

export default function PageWrapperWorkCalendar(props: any) {
    return (
        <Box className={styles.pageWrapper}>
            <div className={styles.container}>
                {props.children}
            </div>
        </Box>
    );
}
